<template>

        <v-container class="mt-5">
            <BaseCard v-if="event && !activesku">
                <VCardTitle class="headline font-weight-light" >
                    {{activeevent.name}}
                </VCardTitle>
                <VCardText>
                    <VLayout wrap>
                        <VFlex>
                            <img :src="event.imgurl" :height="200" />
                        </VFlex>
                        <VFlex>
                            {{event.description}}
                        </VFlex>
                    </VLayout>
                    <VLayout wrap>
                        <VFlex xs12>
                            <span class="title font-weight-light">Select to register</span>
                            <v-list>
                                <v-list-item v-for="(a,i) in skus" @click="selectSku(a)" :key="i" >
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{a.attributes.name}} ${{a.price/100}}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            {{a.metadata.date}}  {{a.metadata.time}}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn icon>
                                            <v-icon>
                                                {{$store.state.icons.checkon}}
                                            </v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </VFlex>
                    </VLayout>
                </VCardText>
                <VCardActions>

                </VCardActions>
            </BaseCard>
            <v-stepper v-else-if="event && activesku" v-model="step"  >
                <v-stepper-header>
                    <v-stepper-step :complete="step > 1" step="1" @click="">Players</v-stepper-step>
                    <v-stepper-step :complete="step > 2" step="2">Confirm</v-stepper-step>
                    <v-stepper-step :complete="step > 3" step="3">Pay</v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                    <v-stepper-content step="1">
                        <TourneyRegistration v-if="event.eventtype==='tourney'" />
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <TeamCard v-if="$store.state.step===2" :sku="activesku" />
                    </v-stepper-content>
                    <v-stepper-content step="3">
                        <ConfirmRegistration v-if="$store.state.step===3" />
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
            <v-btn v-if="activesku" fab bottom right fixed color="black" class="white--text" @click="selectSku(false)">
                <v-icon>{{$store.state.icons.home}}</v-icon>
            </v-btn>
        </v-container>

</template>

<script>
  import {
    mapActions,
    mapMutations,
    mapState
  } from 'vuex'
  import BaseBtn from "../BaseBtn";
  import TourneyRegistration from "@/components/registration/TourneyRegistration";
  import TeamCard from "../registration/TeamCard";
  import ConfirmRegistration from "../registration/ConfirmRegistration";
  import RegistrationById from "../registration/RegistrationById";
  export default {
    props:['eventid'],
    components: {RegistrationById, ConfirmRegistration, TeamCard, TourneyRegistration, BaseBtn},
    name: "EventById",
    data() {
      return {
        loading:false,
        activeplan:0,
        activesubscription:false,
        confirmsubscribedialog:false,
        unsubscribedialog:false
      }
    },
    beforeMount(){
      if(!this.$store.state.activeevent)this.$router.replace('/events')
    },
    mounted() {
      if(this.$store.state.customer===undefined){
        this.getCustomer()
      }
    },
    computed:{
      ...mapState(['activeevent','orders','activesku']),
      step(){
        return this.$store.state.step
      },
      event(){
        return this.activeevent.event
      },
      skus(){
        return this.activeevent.skus
      },
      product(){
        return this.activeevent.product
      }
    },
    watch:{
      customer(){
        this.loading = false
      }
    },
    methods: {
      ...mapActions(['getCustomer']),
      selectSku(s){
        this.$store.commit('setActiveSku',s)
      }
    }
  }
</script>

<style scoped>

</style>